import { GetDamagedCustomerImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImageTabsAlerts/getDamagedCustomerImageTabsAlertsQuery.type';
import { getDamagedCustomerImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImageTabsAlerts/getDamagedCustomerImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getDamagedCustomerImageTabsAlertsQueryOptions = (
  params: GetDamagedCustomerImageTabsAlertsQueryParamType,
) =>
  queryOptions({
    queryKey: ['GET_DAMAGED_CUSTOMER_IMAGE_TABS_ALERTS', params],
    queryFn: () => getDamagedCustomerImageTabsAlertsQueryFunctions(params),
  });
export default getDamagedCustomerImageTabsAlertsQueryOptions;
